import { render, staticRenderFns } from "./FormRecipientFormPage.vue?vue&type=template&id=5973382d&scoped=true&"
import script from "./FormRecipientFormPage.vue?vue&type=script&lang=js&"
export * from "./FormRecipientFormPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5973382d",
  null
  
)

export default component.exports